// eslint-disable-next-line import/no-anonymous-default-export
export default `swagger: "2.0"
info:
  version: "0.0.1"
  title: document-portal-api
# during dev, should point to your local machine
host: localhost:4000
# basePath prefixes all resource paths
basePath: /api
#
schemes:
  # tip: remove http to make production-grade
  - http
# format of bodies a client can send (Content-Type)
consumes:
  - application/json
# format of the responses to the client (Accepts)
produces:
  - application/json

securityDefinitions:
  authorization:
    x-authorize: security/auth.js
    scopes:
      default: Default Scope
  
  clientPortalAuthorization: 
    x-authorize: security/clientPortalAuth.js
    scopes:
      default: Default Scope

security:
  - authorization: [ default ]

tags:
  - name: user
    description: User namespace
  - name: password
    description: Password namespace
  - name: company
    description: Company namespace
  - name: client
    description: Client Namespace
  - name: task
    description: Task Namespace
  - name: engagement
    description: Engagement Namespace
  - name: contact
    description: Contact Namespace
  - name: document_request
    description: Document Request Namespace
  - name: note
    description: Note Namespace
  - name: event
    description: Event Namespace
  - name: field
    description: Field Namespace
  - name: team
    description: Team Namespace
  - name: role
    description: Role Namespace
  - name: view
    description: View Namespace
  - name: invoice
    description: View Namespace
  - name: subscription
    description: View Namespace
  - name: customer
    description: Customer Namespace
  - name: service
    description: Service Namespace
  - name: integration
    description: Integration Namespace
  - name: project
    description: Project Namespace
  - name: client_portal
    description: Client Portal Namespace
  - name: plaid_client
    description: Plaid Client Namespace
  - name: tools
    description: Tools Namespace
  - name: agents
    description: Agents Namespace
  - name: utility
    description: Utilities Namespace
  - name: faq
    description: FAQ Namespace
  - name: communication
    description: Client Communication Logger Namespace
  - name: tracker
    description: Engagement Tracker Namespace
  - name: data_mapper
    description: Data Mapper Namespace
  - name: gmail
    description: Gmail Inbox Namespace
  - name: backoffice
    description: Backoffice Namespace

paths:

  /user/login:
    post:
      description: Attempt to log the user in
      tags: [ user ]
      operationId: login

      security: []

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /user/logout:
    post:
      description: Attempt to logout the user
      tags: [ user ]
      operationId: logout

      security: []

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /user/google/connect:
    get:
      description: Get Google OAuth URL for user
      tags: [ user ]
      operationId: connectGoogle

      security:
        - authorization: [ default ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /user/google/callback:
    get:
      description: Google OAuth callback
      tags: [ user ]
      operationId: googleCallback

      security: []

      responses:
        "302":
          description: Redirect
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /user/google/status:
    get:
      description: Get Google OAuth connection status
      tags: [ user ]
      operationId: googleStatus

      security:
        - authorization: [ default ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /user/google/disconnect:
    delete:
      description: Disconnect Google OAuth
      tags: [ user ]
      operationId: googleDisconnect

      security:
        - authorization: [ default ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /user/create:
    post:
      description: Create a user
      tags: [ user ]
      operationId: create

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /user/{userId}/update:
    post:
      description: Update a user
      tags: [ user ]
      operationId: update

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /user/preferences/update:
    post:
      description: Update user preferences
      tags: [ user ]
      operationId: updatePreferences

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /user/preferences/list:
    get:
      description: Get list of user preferences
      tags: [ user ]
      operationId: listPreferences

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /user/list:
    get:
      description: Fetches a list of users.
      tags: [ user ]
      operationId: list

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /user/search:
    post:
      description: Searches a list of users by their first name or last name
      tags: [ user ]
      operationId: search

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /user/{userId}:
    get:
      description: Fetches a single user.
      tags: [ user ]
      operationId: get

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /user/validate_token:
    get:
      description: Validates a user token
      tags: [ user ]
      operationId: validateToken

      security: []

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"
            
  /task/bulk_update:
    post:
      description: Updates more than one task at once
      tags: [ task ]
      operationId: bulk_update

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /password/reset/verify_token: 
    post:
      description: Verify reset token validity
      tags: [ password ]
      operationId: verifyResetPasswordToken
      security: []

    responses:
      "200":
        description: Success
        schema:
          $ref: "#/definitions/Response"
      default:
        description: Error
        schema:
          $ref: "#/definitions/Response"

  /password/reset:
    post:
      description: Reset the password
      tags: [ password ]
      operationId: resetPassword 

      security: []

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /password/reset/send_token:
    post:
      description: Send email for resetting password
      tags: [ password ]
      operationId: sendResetPasswordToken 
      
      security: []

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /company/create:
    post:
      description: Create a company
      tags: [ company ]
      operationId: create

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /company/list:
    get:
      description: Fetch all companies
      tags: [ company ]
      operationId: list

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /company/{companyId}/update:
    post:
      description: Update a company
      tags: [ company ]
      operationId: update

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /company/{companyId}/logo:
    get:
      description: Get a company
      tags: [ company ]
      operationId: get

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /company/{companyId}:
    get:
      description: Get a company
      tags: [ company ]
      operationId: get

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /engagement/count:
    get:
      description: Counts all the engagements for a specific partner
      tags: [ engagement ]
      operationId: count

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /engagement/create:
    post:
      description: Create an engagement
      tags: [ engagement ]
      operationId: create

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /engagement/multi_create:
    post:
      description: Create multiple engagements for different clients and flows
      tags: [ engagement ]
      operationId: multiCreate

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /engagement/multi_delete:
    post:
      description: Delete multiple engagements for different clients and flows
      tags: [ engagement ]
      operationId: multiDelete

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"            

  /engagement/list:
    get:
      description: Fetch all engagements
      tags: [ engagement ]
      operationId: list

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /engagement/export:
    post:
      description: Retrieve a list of engagements
      tags: [ engagement ]
      operationId: exportList

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /engagement/{engagementId}/update:
    post:
      description: Update an engagement
      tags: [ engagement ]
      operationId: update

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /engagement/{engagementId}:
    get:
      description: Get an engagement
      tags: [ engagement ]
      operationId: get

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /engagement/{engagementId}/delete:
    post:
      description: Delete an engagement
      tags: [ engagement ]
      operationId: delete

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /engagement/{engagementId}/budget/create:
    post:
      description: Create an engagement budget
      tags: [ engagement ]
      operationId: createBudget

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /engagement/{engagementId}/budget/update:
    post:
      description: Update an engagement budget
      tags: [ engagement ]
      operationId: updateBudget

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /engagement/{engagementId}/budget/list:
    get:
      description: Get an engagement budget
      tags: [ engagement ]
      operationId: listBudgets

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /engagement/{engagementId}/budget/remove:
    post:
      description: Create an engagement budget
      tags: [ engagement ]
      operationId: removeBudget

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /task/create:
    post:
      description: Create a task
      tags: [ task ]
      operationId: create

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /task/list:
    get:
      description: Fetch all tasks
      tags: [ task ]
      operationId: list

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /task/{taskId}/update:
    post:
      description: Update a task
      tags: [ task ]
      operationId: update

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /task/{taskId}/send_back:
    post:
      description: Send a task back to the previous step with a reason
      tags: [ task ]
      operationId: sendBack

      security: [
        authorization: [ default ]
      ]


      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /task/{taskId}:
    get:
      description: Get a task
      tags: [ task ]
      operationId: get

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /task/{taskId}/mark_read:
    get:
      description: Sets the task as read
      tags: [ task ]
      operationId: markRead

      security: []

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /client/create:
    post:
      description: Create a client
      tags: [ client ]
      operationId: create

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /client/search:
    post:
      description: Create a client
      tags: [ client ]
      operationId: search

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /client/list:
    get:
      description: Fetch all clients
      tags: [ client ]
      operationId: list

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"
            
  /client/summary:
    get:
      description: Get a full client breakdown for a company
      tags: [ client ]
      operationId: summary

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /client/export:
    post:
      description: Retrieve a CSV file of the current filtered clients
      tags: [ client ]
      operationId: exportList

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /client/{clientId}/update:
    post:
      description: Update a client
      tags: [ client ]
      operationId: update

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /client/{clientId}:
    get:
      description: Get a client
      tags: [ client ]
      operationId: get

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /client/{clientId}/remove_contact:
    post:
      description: Delete an contact from a client
      tags: [ client ]
      operationId: remove_contact

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"
  
  /client/{clientId}/delete:
    post:
      description: Delete an client
      tags: [ client ]
      operationId: delete

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /client/{clientId}/custom_field:
    get:
      description: Get all the custom fields for a Client
      tags: [ client ]
      operationId: getCustomFields

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /client/{clientId}/drive_folder:
    get:
      description: Get the active Google Drive folder mapping for a client
      tags: [ client ]
      operationId: getDriveFolder

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /client/{clientId}/drive_folder/provision:
    post:
      description: Auto-provision a Google Drive folder for a client
      tags: [ client ]
      operationId: provision

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /client/{clientId}/drive_folder/search:
    get:
      description: Search Google Drive for folders matching the client name
      tags: [ client ]
      operationId: searchDriveFolder

      security: [
        authorization: [ default ]
      ]

      parameters:
        - name: query
          in: query
          type: string
          required: false
        - name: pageToken
          in: query
          type: string
          required: false

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /client/{clientId}/drive_folder/map:
    post:
      description: Manually map an existing Google Drive folder to a client
      tags: [ client ]
      operationId: mapDriveFolder

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /client/{clientId}/drive_folder/rename:
    post:
      description: Rename the linked Google Drive folder to match the client name
      tags: [ client ]
      operationId: renameDriveFolder

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /client/{clientId}/drive_folder/unlink:
    post:
      description: Remove the active Google Drive folder mapping for a client
      tags: [ client ]
      operationId: unlinkDriveFolder

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /client/group/list:
    get:
      description: Fetches a list of client groups
      tags: [ client ]
      operationId: listGroups

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /client/group/{clientGroupId}/update:
    post:
      description: Updates a specific client group
      tags: [ client ]
      operationId: updateClientGroup

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /client/group/{clientGroupId}:
    get:
      description: Fetches a specified client group
      tags: [ client ]
      operationId: getClientGroup

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /client/group/create:
    post:
      description: Creates a new client group
      tags: [ client ]
      operationId: createClientGroup

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /contact/create:
    post:
      description: Create a contact
      tags: [ contact ]
      operationId: create

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /contact/list:
    get:
      description: Fetch all contacts
      tags: [ contact ]
      operationId: list

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /contact/search:
    post:
      description: Search for contacts
      tags: [ contact ]
      operationId: search

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /contact/{contactId}/update:
    post:
      description: Update a contact
      tags: [ contact ]
      operationId: update

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /contact/{contactId}/assign:
    post:
      description: Assign contact to a client
      tags: [ contact ]
      operationId: assign

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /contact/{contactId}:
    get:
      description: Get a contact
      tags: [ contact ]
      operationId: get

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"


  /document_request/create:
      post:
        description: Creates a new document request
        tags: [ document_request ]
        operationId: create
        security: [
            authorization: [
              default
            ]
        ]
        responses:
          "200":
            description: Success
            schema:
              $ref: "#/definitions/Response"
          default:
            description: Error
            schema:
              $ref: "#/definitions/Response"


  /document_request/upload:
    post:
      description: Handles client uploads
      tags: [ document_request ]
      operationId: upload

      security: []

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"
            

  /document_request/list:
    get:
      description: Lists all the document requests for a particular client
      tags: [ document_request ]
      operationId: list

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /document_request/download/{shortId}:
    get:
      description: Creates a new document request
      tags: [ document_request ]
      operationId: download

      security: [
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /document_request/{shortId}:
    get:
      description: Fetches a document request
      tags: [ document_request ]
      operationId: get

      security: []

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /flow/list:
    get:
      description: Fetches all the flows for a company
      tags: [ flow ]
      operationId: list

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /flow/state/list:
    get:
      description: Fetches all the flow states for a flow
      tags: [ flow ]
      operationId: listStates

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /flow/{flowId}:
    get:
      description: Fetches a single flow
      tags: [ flow ]
      operationId: get

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /note/{noteId}/update:
    post:
      description: Update a note
      tags: [ note ]
      operationId: update

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /note/create:
    post:
      description: Create a note
      tags: [ note ]
      operationId: create

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /note/list:
    get:
      description: Fetch all notes
      tags: [ note ]
      operationId: list

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /note/{noteId}:
    get:
      description: Get a note
      tags: [ note ]
      operationId: get

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /event/list:
    get:
      description: Fetch all events for a client or engagement
      tags: [ event ]
      operationId: list

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /field/{fieldId}/update:
    post:
      description: Update a field
      tags: [ field ]
      operationId: update

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /field/create:
    post:
      description: Create a field
      tags: [ field ]
      operationId: create

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /field/list:
    get:
      description: Fetch all fields
      tags: [ field ]
      operationId: list

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /field/{fieldId}:
    get:
      description: Get a field
      tags: [ field ]
      operationId: get

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /team/{teamId}/update:
    post:
      description: Update a team
      tags: [ team ]
      operationId: update

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /team/create:
    post:
      description: Create a team
      tags: [ team ]
      operationId: create

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /team/list:
    get:
      description: Fetch all teams for a company
      tags: [ team ]
      operationId: list

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /team/{teamId}:
    get:
      description: Get a team
      tags: [ team ]
      operationId: get

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /role/{roleId}/update:
    post:
      description: Update a role
      tags: [ role ]
      operationId: update

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /role/create:
    post:
      description: Create a role
      tags: [ role ]
      operationId: create

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /role/list:
    get:
      description: Fetch all roles for a company
      tags: [ role ]
      operationId: list

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /role/{roleId}:
    get:
      description: Get a role
      tags: [ role ]
      operationId: get

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /view/create:
    post:
      description: Create a view
      tags: [ view ]
      operationId: create

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /view/list:
    get:
      description: Fetch all views for a user
      tags: [ view ]
      operationId: list

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /view/{viewId}/subscribe:
    post:
      description: Toggle a user's subscription to a view.
      tags: [ view ]
      operationId: subscribeToView
      security:
        - authorization: [ default ]
      parameters:
        - name: viewId
          in: path
          required: true
          type: integer
          description: ID of the view.
        - name: body
          in: body
          required: true
          schema:
            type: object
            properties:
              userId:
                type: integer
              subscribe:
                type: boolean
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /view/{viewId}/subscriptionStatus:
    get:
      description: Get the subscription status for a view for the current user.
      tags: [ view ]
      operationId: getSubscriptionStatus
      security:
        - authorization: [ default ]
      parameters:
        - name: viewId
          in: path
          required: true
          type: integer
          description: ID of the view.
        - name: userId
          in: query
          required: true
          type: integer
          description: ID of the current user.
      responses:
        "200":
          description: Subscription status retrieved successfully.
          schema:
            type: object
            properties:
              success:
                type: boolean
              isSubscribed:
                type: boolean
        default:
          description: Error retrieving subscription status.
          schema:
            $ref: "#/definitions/Response"

  /view/{viewId}/update:
    post:
      description: Update a view
      tags: [ view ]
      operationId: update

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /view/{userId}/view_user/update:
    post:
        description: Update a view_user record
        tags: [ view ]
        operationId: updateViewUser

        security: [
          authorization: [ default ]
        ]
 
        responses:
          "200":
            description: Success
            schema:
              $ref: "#/definitions/Response"
          default:
            description: Error
            schema:
              $ref: "#/definitions/Response"

  /view/{userId}/view_user/list:
    get:
      description: List view_user records
      tags: [ view ]
      operationId: listViewUser

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /view/{viewId}:
    get:
      description: Get a view
      tags: [ view ]
      operationId: get

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /engagement/template/create:
    post:
      description: Create an engagement template
      tags: [ engagement ]
      operationId: createTemplate

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /engagement/template/list:
    get:
      description: Fetch all engagement templates for a company
      tags: [ engagement ]
      operationId: listTemplates

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /engagement/template/{engagementTemplateId}/update:
    post:
      description: Update an engagement template
      tags: [ engagement ]
      operationId: updateTemplate

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /engagement/template/{engagementTemplateId}:
    get:
      description: Get an engagement template
      tags: [ engagement ]
      operationId: getTemplate

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /custom/invoice/create:
    post:
      description: Create an invoice
      tags: [ invoice ]
      operationId: create

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /custom/invoice/sync:
    post:
      description: Syncs a list of invoices to the necessary integrations
      tags: [ invoice ]
      operationId: sync

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /custom/invoice/list:
    get:
      description: Fetch all invoices for a client
      tags: [ invoice ]
      operationId: list

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /custom/invoice/{invoiceId}/update:
    post:
      description: Update an invoice
      tags: [ invoice ]
      operationId: update

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /custom/invoice/{invoiceId}:
    get:
      description: Get an invoice
      tags: [ invoice ]
      operationId: get

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /custom/subscription/create:
    post:
      description: Create a subscription
      tags: [ subscription ]
      operationId: create

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /custom/subscription/list:
    get:
      description: Fetch all subscriptions for a client
      tags: [ subscription ]
      operationId: list

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /custom/subscription/{subscriptionId}/update:
    post:
      description: Update an subscription
      tags: [ subscription ]
      operationId: update

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /custom/subscription/{subscriptionId}:
    get:
      description: Get a subscription
      tags: [ subscription ]
      operationId: get

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /custom/service/list:
    get:
      description: Fetch all services for a client
      tags: [ service ]
      operationId: list

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /support/create:
    post:
      description: Create a card
      tags: [ support ]
      operationId: create

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /customer/list:
    get:
      description: Lists customers of client
      tags: [ customer ]
      operationId: list

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /integration/qbo/auth:
    get:
      description: Get Consent UI Link for Intuit OAuth
      tags: [ integration ]
      operationId: qboAuth

      security: []

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /integration/qbo/redirect:
    get:
      description: Get Consent UI Link for Intuit OAuth
      tags: [ integration ]
      operationId: qboRedirect

      security: []

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /integration/qbo/companies:
    get:
      description: List all authenticated QBO companies (realms)
      tags: [ integration ]
      operationId: qboCompanies

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /integration/qbo/companies/{realmId}/customers:
    get:
      description: Get QBO customers for a given realm
      tags: [ integration ]
      operationId: qboCustomers

      security: [
        authorization: [ default ]
      ]

      x-scheme: /resource/sub-resource/identifier/action

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /integration/qbo/map-client:
    post:
      description: Map a workflow client to a QBO realm
      tags: [ integration ]
      operationId: qboMapClient

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /integration/qbo/client_status:
    post:
      description: Whether a client is connected to a QuickBooks Online company
      tags: [ integration ]
      operationId: qboClientStatus

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /custom/project/list:
    get:
      description: Get a list of TeamWork projects
      tags: [ project ]
      operationId: list

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /engagement/recurring/{recurringEngagementId}/update:
    post:
      description: Update a recurring engagement record
      tags: [ engagement ]
      operationId: updateRecurringEngagement

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /engagement/recurring/list:
    get:
      description: Get list of recurring engagements
      tags: [ engagement ]
      operationId: listRecurringEngagements

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/bookkeeping/download_summaries:
    post:
      description: Downloads the Excel bookkeeping summary
      tags: [ tools ]
      operationId: downloadBookkeepingSummaries

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/bookkeeping/classify:
    post:
      description: Classifies transactions
      tags: [ tools ]
      operationId: classifyBookkeepingTransactions

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/bookkeeping/categorize_from_gl:
    post:
      description: Categorizes transactions by fuzzy-matching their descriptions against a general ledger reference
      tags: [ tools ]
      operationId: categorizeFromGl

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/bookkeeping/identify_bank_accounts_from_gl:
    post:
      description: Identifies which general ledger account names are likely real-world bank or credit card accounts
      tags: [ tools ]
      operationId: identifyBankAccountsFromGl

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/bookkeeping/convert_currency:
    post:
      description: Converts foreign-currency transactions to CAD using the Bank of Canada daily exchange rate for each transaction's date
      tags: [ tools ]
      operationId: convertCurrency

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/bookkeeping/trial_balance:
    post:
      description: getBookkeepingTrialBalance
      tags: [ tools ]
      operationId: getBookkeepingTrialBalance
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/bookkeeping/get_gl_opening_balance_lines:
    post:
      description: getGlOpeningBalanceLines
      tags: [ tools ]
      operationId: getGlOpeningBalanceLines
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/bookkeeping/map_coa:
    get:
      description: getCoaMapping
      tags: [ tools ]
      operationId: getCoaMapping
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"
    post:
      description: mapCoaSuggest
      tags: [ tools ]
      operationId: mapCoaSuggest
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"
    put:
      description: mapCoaSave
      tags: [ tools ]
      operationId: mapCoaSave
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/bookkeeping/ensure_engagement:
    post:
      description: ensureEngagement
      tags: [ tools ]
      operationId: ensureEngagement
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/bookkeeping/register_statements:
    post:
      description: registerStatements
      tags: [ tools ]
      operationId: registerStatements
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/bookkeeping/statement_registry:
    post:
      description: readStatementRegistry
      tags: [ tools ]
      operationId: readStatementRegistry
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/bookkeeping/imported_files:
    get:
      description: listImportedFiles
      tags: [ tools ]
      operationId: listImportedFiles
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/bookkeeping/imported_files_remove:
    post:
      description: removeImportedFile
      tags: [ tools ]
      operationId: removeImportedFile
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/bookkeeping/statement_reading:
    get:
      description: readStatementReading
      tags: [ tools ]
      operationId: readStatementReading
      security: [
        authorization: [ default ]
      ]
      parameters:
        - name: statementId
          in: query
          required: true
          type: string
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

    post:
      description: correctStatementReading
      tags: [ tools ]
      operationId: correctStatementReading
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/bookkeeping/statement_correction_to_books:
    post:
      description: putStatementCorrectionInTheBooks
      tags: [ tools ]
      operationId: putStatementCorrectionInTheBooks
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/bookkeeping/statement_lines_correction_batch:
    post:
      description: correctSeveralStatementLines
      tags: [ tools ]
      operationId: correctSeveralStatementLines
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/bookkeeping/reread_statement_file:
    post:
      description: rereadStatementFile
      tags: [ tools ]
      operationId: rereadStatementFile
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/bookkeeping/record_statement_by_hand:
    post:
      description: recordStatementByHand
      tags: [ tools ]
      operationId: recordStatementByHand
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/bookkeeping/earnings_close:
    get:
      description: What the prior year's profit is and which equity account it would close into
      tags: [ tools ]
      operationId: getEarningsClose
      security: [ authorization: [ default ] ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"

  /tools/bookkeeping/earnings_close/update:
    post:
      description: Records which equity account an imported prior year's profit closes into
      tags: [ tools ]
      operationId: updateEarningsClose
      security: [ authorization: [ default ] ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"

  /tools/bookkeeping/opening_balances:
    get:
      description: getOpeningBalances
      tags: [ tools ]
      operationId: getOpeningBalances
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"
    post:
      description: saveOpeningBalances
      tags: [ tools ]
      operationId: saveOpeningBalances
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/bookkeeping/chart_of_accounts:
    post:
      description: createChartOfAccount
      tags: [ tools ]
      operationId: createChartOfAccount
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/bookkeeping/chart_of_accounts/retire:
    post:
      description: retireChartAccount
      tags: [ tools ]
      operationId: retireChartAccount
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/bookkeeping/chart_of_accounts/restore:
    post:
      description: restoreChartAccount
      tags: [ tools ]
      operationId: restoreChartAccount
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/bookkeeping/engagement_transactions:
    get:
      description: getEngagementTransactions
      tags: [ tools ]
      operationId: getEngagementTransactions
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"
    post:
      description: saveEngagementTransactions
      tags: [ tools ]
      operationId: saveEngagementTransactions
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"
    delete:
      description: clearEngagementTransactions
      tags: [ tools ]
      operationId: clearEngagementTransactions
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/bookkeeping/engagement_adjusting_entries:
    get:
      description: getEngagementAdjustingEntries
      tags: [ tools ]
      operationId: getEngagementAdjustingEntries
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"
    post:
      description: saveEngagementAdjustingEntries
      tags: [ tools ]
      operationId: saveEngagementAdjustingEntries
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/bookkeeping/engagement_fs_notes:
    get:
      description: getEngagementFsNotes
      tags: [ tools ]
      operationId: getEngagementFsNotes
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"
    post:
      description: saveEngagementFsNotes
      tags: [ tools ]
      operationId: saveEngagementFsNotes
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/bookkeeping/rerun_cross_checks:
    post:
      description: rerunCrossChecks
      tags: [ tools ]
      operationId: rerunCrossChecks
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/bookkeeping/update_engagement_context:
    post:
      description: updateEngagementContext
      tags: [ tools ]
      operationId: updateEngagementContext
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/bookkeeping/engagement_years:
    get:
      description: getEngagementYears
      tags: [ tools ]
      operationId: getEngagementYears
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/bookkeeping/engagement_deliverable:
    get:
      description: getEngagementDeliverable
      tags: [ tools ]
      operationId: getEngagementDeliverable
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/bookkeeping/trial_balance_import_commit:
    post:
      description: commitTrialBalanceImport
      tags: [ tools ]
      operationId: commitTrialBalanceImport
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/bookkeeping/qbo_trial_balance_pull:
    post:
      description: Pull an engagement's current and prior-year trial balance from the client's QuickBooks company and keep what QuickBooks returned
      tags: [ tools ]
      operationId: pullQuickBooksTrialBalance

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/bookkeeping/qbo_trial_balance_preview:
    post:
      description: Describe what a kept QuickBooks pull would put in the books
      tags: [ tools ]
      operationId: previewQuickBooksTrialBalance

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/bookkeeping/statement_line_detail:
    post:
      description: What makes up one or more statement lines - the figure split into opening, movements and adjusting entries, and every source behind it
      tags: [ tools ]
      operationId: describeStatementLines

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/bookkeeping/qbo_tax_setup:
    post:
      description: QuickBooks's sales tax codes, their rates and the accounts' default tax codes, read from the pull the books came from
      tags: [ tools ]
      operationId: describeQuickBooksTaxSetup

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/bookkeeping/qbo_account_ledger:
    post:
      description: Pull and keep QuickBooks's ledger entries for one account, and say whether they reach the trial balance figure
      tags: [ tools ]
      operationId: pullQuickBooksAccountLedger

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/bookkeeping/qbo_ledger_entry_attachments:
    post:
      description: Every file QuickBooks has attached to one ledger entry's transaction, found by what it's attached to
      tags: [ tools ]
      operationId: describeAttachmentsForLedgerEntry

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/bookkeeping/qbo_ledger_entry_attachment_download:
    get:
      description: Returns the bytes of one attachment QuickBooks is holding on a ledger entry's transaction
      tags: [ tools ]
      operationId: downloadLedgerEntryAttachment

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/bookkeeping/qbo_journal_preview:
    post:
      description: Lay out one accepted adjusting entry as it would be booked in the client's QuickBooks company, with every reason it cannot be
      tags: [ tools ]
      operationId: describeAdjustingEntryToBook

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/bookkeeping/qbo_journal_book:
    post:
      description: Book one accepted adjusting entry into the client's QuickBooks company after the preparer confirmed it
      tags: [ tools ]
      operationId: bookAdjustingEntryInQuickBooks

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/bookkeeping/qbo_opening_balance_equity_preview:
    post:
      description: Lay out the journals that would move QuickBooks's Opening Balance Equity into an equity account
      tags: [ tools ]
      operationId: describeOpeningBalanceEquityReclassification

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/bookkeeping/qbo_opening_balance_equity_book:
    post:
      description: Book one Opening Balance Equity reclassification journal into the client's QuickBooks company after the preparer confirmed it
      tags: [ tools ]
      operationId: bookOpeningBalanceEquityReclassification

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/bookkeeping/qbo_journal_remove:
    post:
      description: Delete a journal this engagement booked from the client's QuickBooks company and apply its adjusting entry in the tool again
      tags: [ tools ]
      operationId: removeJournalFromQuickBooks

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/bookkeeping/qbo_journal_client_entry_preview:
    post:
      description: Lay an adjusting entry out against the journal the client entered for it in QuickBooks, for the preparer to confirm before it is recorded
      tags: [ tools ]
      operationId: describeClientEntryToRecord

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/bookkeeping/qbo_journal_client_entry_record:
    post:
      description: Record that the client entered an adjusting entry in QuickBooks themselves, so the next saved pull settles it and it is not counted twice
      tags: [ tools ]
      operationId: recordClientEntryInQuickBooks

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/bookkeeping/qbo_journals:
    post:
      description: List every journal this engagement has booked into QuickBooks, removed ones included
      tags: [ tools ]
      operationId: listJournalsBookedInQuickBooks

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/bookkeeping/qbo_changes_since_pull:
    post:
      description: Read QuickBooks again and list every account whose balance has moved since the engagement's books were pulled
      tags: [ tools ]
      operationId: findQuickBooksChangesSincePull

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/bookkeeping/qbo_trial_balance_link:
    post:
      description: Link QuickBooks accounts to the client's chart of accounts
      tags: [ tools ]
      operationId: linkQuickBooksAccounts

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/bookkeeping/qbo_trial_balance_unlink:
    post:
      description: Remove the link between a chart account and its QuickBooks account
      tags: [ tools ]
      operationId: unlinkQuickBooksAccount

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/bookkeeping/qbo_trial_balance_commit:
    post:
      description: Make a kept QuickBooks pull the engagement's books
      tags: [ tools ]
      operationId: commitQuickBooksTrialBalance

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/bookkeeping/qbo_entries_to_book:
    post:
      description: List the engagement's accepted adjusting entries as they would be entered in QuickBooks
      tags: [ tools ]
      operationId: listEntriesToBookInQuickBooks

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/bookkeeping/trial_balance_import_clear:
    post:
      description: clearTrialBalanceImport
      tags: [ tools ]
      operationId: clearTrialBalanceImport
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/bookkeeping/trial_balance_import_preview:
    post:
      description: previewTrialBalanceImport
      tags: [ tools ]
      operationId: previewTrialBalanceImport
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/bookkeeping/package_checklist:
    get:
      description: getPackageChecklist
      tags: [ tools ]
      operationId: getPackageChecklist
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

    post:
      description: recordPackageItemDecision
      tags: [ tools ]
      operationId: recordPackageItemDecision
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/bookkeeping/package_checklist_delete:
    post:
      description: removeManualPackageItem
      tags: [ tools ]
      operationId: removeManualPackageItem
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/bookkeeping/package_document:
    post:
      description: uploadPackageDocument
      tags: [ tools ]
      operationId: uploadPackageDocument
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/bookkeeping/engagement_presentation_settings:
    get:
      description: getEngagementPresentationSettings
      tags: [ tools ]
      operationId: getEngagementPresentationSettings
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

    post:
      description: setEngagementPresentationSettings
      tags: [ tools ]
      operationId: setEngagementPresentationSettings
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/bookkeeping/roll_forward:
    post:
      description: rollForward
      tags: [ tools ]
      operationId: rollForward
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/bookkeeping/engagement_signoff:
    get:
      description: getEngagementSignoff
      tags: [ tools ]
      operationId: getEngagementSignoff
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"
    post:
      description: createEngagementSignoff
      tags: [ tools ]
      operationId: createEngagementSignoff
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/bookkeeping/year_end_package:
    get:
      description: getYearEndPackage
      tags: [ tools ]
      operationId: getYearEndPackage
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"
    post:
      description: createYearEndPackage
      tags: [ tools ]
      operationId: createYearEndPackage
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/bookkeeping/client_requests:
    get:
      description: getClientRequests
      tags: [ tools ]
      operationId: getClientRequests
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"
    post:
      description: createClientRequests
      tags: [ tools ]
      operationId: createClientRequests
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"
    put:
      description: updateClientRequests
      tags: [ tools ]
      operationId: updateClientRequests
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"
    delete:
      description: deleteClientRequests
      tags: [ tools ]
      operationId: deleteClientRequests
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/bookkeeping/client_requests_send:
    post:
      description: createClientRequestsSend
      tags: [ tools ]
      operationId: createClientRequestsSend
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/bookkeeping/lead_sheets:
    get:
      description: getLeadSheets
      tags: [ tools ]
      operationId: getLeadSheets
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"
    put:
      description: updateLeadSheets
      tags: [ tools ]
      operationId: updateLeadSheets
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/bookkeeping/record_missed_statement_line:
    post:
      description: Records a line that is on the statement but that the reader never produced
      tags: [ tools ]
      operationId: recordMissedStatementLine
      security: [ authorization: [ default ] ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"

  /tools/bookkeeping/accept_unreconciled_statements:
    post:
      description: Records that a preparer accepts working on books their statements do not support
      tags: [ tools ]
      operationId: acceptUnreconciledStatements
      security: [ authorization: [ default ] ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"

  /tools/bookkeeping/approve_unreconciled_statements:
    post:
      description: Approves a previously-requested override of the reconciliation check, by someone other than whoever requested it
      tags: [ tools ]
      operationId: approveUnreconciledStatements
      security: [ authorization: [ default ] ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"

  /tools/bookkeeping/industries:
    get:
      description: Lists every industry a preparer can choose for a client
      tags: [ tools ]
      operationId: listIndustries
      security: [ authorization: [ default ] ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"

    post:
      description: Adds a new industry a preparer can select
      tags: [ tools ]
      operationId: addIndustry
      security: [ authorization: [ default ] ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"

  /tools/bookkeeping/statement_lines:
    get:
      description: Lists statements whose lines do not account for the movement they print
      tags: [ tools ]
      operationId: getStatementsThatDoNotReconcile
      security: [ authorization: [ default ] ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"

    post:
      description: Records a line that is on the statement but never made it into the books
      tags: [ tools ]
      operationId: addLineReadOffTheStatement
      security: [ authorization: [ default ] ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"

  /tools/bookkeeping/flip_signs_preview:
    get:
      description: Predicts which of an account's statements stop or start reconciling if its signs are flipped
      tags: [ tools ]
      operationId: previewFlipSigns
      security: [ authorization: [ default ] ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"

  /tools/bookkeeping/transfer_pairs:
    post:
      description: Records pairs of statement lines as payments between the client's own accounts
      tags: [ tools ]
      operationId: recordTransferPairs
      security: [ authorization: [ default ] ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"

  /tools/bookkeeping/transfer_pairs/release:
    post:
      description: Undoes a transfer match so both legs post again
      tags: [ tools ]
      operationId: releaseTransferPair
      security: [ authorization: [ default ] ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"

  /tools/bookkeeping/bank_account_links:
    get:
      description: Lists each imported bank or card account with the chart account it posts to
      tags: [ tools ]
      operationId: getBankAccountLinks
      security: [ authorization: [ default ] ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"

  /tools/bookkeeping/bank_account_links/update:
    post:
      description: Points an imported bank or card account at a different account on the client's chart
      tags: [ tools ]
      operationId: updateBankAccountLink
      security: [ authorization: [ default ] ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"

  /tools/bookkeeping/lead_sheet_documents:
    get:
      description: getLeadSheetDocuments
      tags: [ tools ]
      operationId: getLeadSheetDocuments
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"
    put:
      description: updateLeadSheetDocuments
      tags: [ tools ]
      operationId: updateLeadSheetDocuments
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"
    delete:
      description: deleteLeadSheetDocuments
      tags: [ tools ]
      operationId: deleteLeadSheetDocuments
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/bookkeeping/canonical_accounts:
    get:
      description: getCanonicalAccounts
      tags: [ tools ]
      operationId: getCanonicalAccounts
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/bookkeeping/reconciliation_action:
    post:
      description: createReconciliationAction
      tags: [ tools ]
      operationId: createReconciliationAction
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"
    put:
      description: updateReconciliationAction
      tags: [ tools ]
      operationId: updateReconciliationAction
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/bookkeeping/fixed_assets:
    get:
      description: getFixedAssets
      tags: [ tools ]
      operationId: getFixedAssets
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"
    post:
      description: createFixedAssets
      tags: [ tools ]
      operationId: createFixedAssets
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"
    put:
      description: updateFixedAssets
      tags: [ tools ]
      operationId: updateFixedAssets
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"
    delete:
      description: deleteFixedAssets
      tags: [ tools ]
      operationId: deleteFixedAssets
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/bookkeeping/fixed_asset_register:
    post:
      description: fixedAssetRegister
      tags: [ tools ]
      operationId: fixedAssetRegister
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/bookkeeping/engagement_templates:
    get:
      description: getEngagementTemplates
      tags: [ tools ]
      operationId: getEngagementTemplates
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/bookkeeping/batch_tax_codes:
    post:
      description: batchTaxCodes
      tags: [ tools ]
      operationId: batchTaxCodes
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/bookkeeping/infer_industry:
    post:
      description: inferIndustry
      tags: [ tools ]
      operationId: inferIndustry
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/afs/documentation_checklist:
    post:
      description: Fetch the documentation checklist for a client's engagement
      tags: [ tools ]
      operationId: documentationChecklist
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/afs/verify_document_again:
    post:
      description: Runs the document check again when the last attempt finished without an answer
      tags: [ tools ]
      operationId: verifyDocumentAgain
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/afs/agent_mode_clear:
    post:
      description: Clear the agent mode state for a client
      tags: [ tools ]
      operationId: agentModeClear
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /playbooks/list:
    post:
      description: The agents this firm can run (its own and the built-in ones), each with its current version
      tags: [ playbooks ]
      operationId: listPlaybooks
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /playbooks/runs/start:
    post:
      description: Starts an agent on one or more of the firm's clients; clients it cannot work on are recorded as skipped with the reason
      tags: [ playbooks ]
      operationId: startPlaybookRuns
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /playbooks/runs/list:
    post:
      description: One page of the firm's per-client agent runs, filtered and sorted, with outcome counts for the filtered scope
      tags: [ playbooks ]
      operationId: listPlaybookRuns
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /playbooks/runs/filter_options:
    post:
      description: The teams, people, agents, periods and starters that the firm's agent runs can be filtered by
      tags: [ playbooks ]
      operationId: listPlaybookRunFilterOptions
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /playbooks/runs/get:
    post:
      description: One agent run with its agent version, client, who started it and any per-client child runs
      tags: [ playbooks ]
      operationId: getPlaybookRun
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /playbooks/runs/steps:
    post:
      description: An agent run's recorded steps after a given step number
      tags: [ playbooks ]
      operationId: listPlaybookRunSteps
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /playbooks/runs/cancel:
    post:
      description: Cancels an agent run that has not finished, and its unfinished child runs
      tags: [ playbooks ]
      operationId: cancelPlaybookRun
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /playbooks/runs/resume:
    post:
      description: Resumes an agent run that stopped part-way, or the interrupted child runs of a multi-client run
      tags: [ playbooks ]
      operationId: resumePlaybookRun
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"










  /playbooks/skills/list:
    post:
      description: undefined
      tags: [ playbooks ]
      operationId: listPlaybookSkills
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /playbooks/skills/get:
    post:
      description: undefined
      tags: [ playbooks ]
      operationId: getPlaybookSkill
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /playbooks/skills/save:
    post:
      description: undefined
      tags: [ playbooks ]
      operationId: savePlaybookSkill
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /playbooks/skills/archive:
    post:
      description: undefined
      tags: [ playbooks ]
      operationId: archivePlaybookSkill
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /playbooks/skills/build/start:
    post:
      description: Opens a conversation with the skill development guide to write a new skill
      tags: [ playbooks ]
      operationId: startSkillBuild
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /playbooks/skills/build/get:
    post:
      description: A skill conversation with its brief and the draft skill as it stands
      tags: [ playbooks ]
      operationId: getSkillBuild
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /playbooks/skills/build/message:
    post:
      description: Sends a message to the skill development guide and returns its reply with the updated brief and draft
      tags: [ playbooks ]
      operationId: sendSkillBuildMessage
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /playbooks/skills/build/import_procedure:
    post:
      description: Starts a skill conversation from a procedure the person already has written down
      tags: [ playbooks ]
      operationId: importSkillBuildProcedure
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /playbooks/skills/build/finish:
    post:
      description: Records that a skill conversation's draft was reviewed and saved as a skill, and ends it
      tags: [ playbooks ]
      operationId: finishSkillBuild
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /playbooks/tools/list:
    post:
      description: undefined
      tags: [ playbooks ]
      operationId: listPlaybookToolCatalogue
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /playbooks/toolbox/list:
    post:
      description: The firm's toolbox — every tool, what it does to the world, and how many skills and playbooks use it
      tags: [ playbooks ]
      operationId: listPlaybookToolbox
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /playbooks/links/confirm:
    post:
      description: Records once that an email address belongs to one of the firm's clients, under the confirming person's name
      tags: [ playbooks ]
      operationId: confirmPlaybookEmailLink
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /playbooks/rules/list:
    post:
      description: Every live rule the firm has set for its playbooks
      tags: [ playbooks ]
      operationId: listPlaybookRules
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /playbooks/rules/create:
    post:
      description: Sets a rule firm-wide, for one client or for one playbook, or turns a rejection into one
      tags: [ playbooks ]
      operationId: createPlaybookRule
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /playbooks/rules/retire:
    post:
      description: Retires a rule so later runs are not handed it
      tags: [ playbooks ]
      operationId: retirePlaybookRule
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /playbooks/decisions/corrections:
    post:
      description: Where people correct a playbook, judgment by judgment
      tags: [ playbooks ]
      operationId: describePlaybookCorrections
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /playbooks/decisions/export:
    post:
      description: Decision Records as JSON lines for training or study, with the chosen exclusions; administrators only
      tags: [ playbooks ]
      operationId: exportPlaybookDecisions
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /playbooks/archive:
    post:
      description: Takes a playbook off the firm's list, keeping its versions, runs and results
      tags: [ playbooks ]
      operationId: archivePlaybook
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /playbooks/facts/list:
    post:
      description: The facts people have confirmed about a client, or about every client
      tags: [ playbooks ]
      operationId: listClientFacts
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /playbooks/facts/confirm:
    post:
      description: Records a fact about a client under the confirming person's name
      tags: [ playbooks ]
      operationId: confirmClientFact
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /playbooks/facts/retire:
    post:
      description: Retires a fact that no longer holds
      tags: [ playbooks ]
      operationId: retireClientFact
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /playbooks/runs/outputs/list:
    post:
      description: undefined
      tags: [ playbooks ]
      operationId: listPlaybookRunOutputs
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /playbooks/runs/outputs/download:
    post:
      description: undefined
      tags: [ playbooks ]
      operationId: downloadPlaybookRunOutput
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /playbooks/runs/review/execute:
    post:
      description: undefined
      tags: [ playbooks ]
      operationId: executePlaybookAction
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /playbooks/runs/review/journal_preview:
    post:
      description: undefined
      tags: [ playbooks ]
      operationId: previewPlaybookJournalBooking
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /playbooks/runs/review/journal_book:
    post:
      description: undefined
      tags: [ playbooks ]
      operationId: bookPlaybookJournal
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /playbooks/runs/review/journal_remove:
    post:
      description: undefined
      tags: [ playbooks ]
      operationId: removePlaybookJournal
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"
  /playbooks/build/skills:
    post:
      description: undefined
      tags: [ playbooks ]
      operationId: setPlaybookBuildSkill
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"
  /playbooks/build/link_drafted_skill:
    post:
      description: undefined
      tags: [ playbooks ]
      operationId: linkPlaybookBuildDraftedSkill
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"
  /playbooks/build/sources:
    post:
      description: undefined
      tags: [ playbooks ]
      operationId: setPlaybookBuildSources
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /playbooks/runs/check_sources:
    post:
      description: undefined
      tags: [ playbooks ]
      operationId: checkPlaybookRunSources
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /playbooks/runs/connected_clients:
    post:
      description: The firm's active clients a playbook can run on now, with every required source linked
      tags: [ playbooks ]
      operationId: listPlaybookConnectedClients
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"
  /playbooks/categories/list:
    post:
      description: The categories agents sit under in this firm, with how many agents each holds
      tags: [ playbooks ]
      operationId: listPlaybookCategories
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"
  /playbooks/build/start:
    post:
      description: Opens a conversation with the agent development guide to build a new agent, or to change one the viewer owns
      tags: [ playbooks ]
      operationId: startPlaybookBuild
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /playbooks/build/get:
    post:
      description: A build conversation with its brief, suggested tools and skills, draft and test runs; never the agent instructions
      tags: [ playbooks ]
      operationId: getPlaybookBuild
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /playbooks/build/message:
    post:
      description: Sends a message to the agent development guide and returns its reply with the updated brief
      tags: [ playbooks ]
      operationId: sendPlaybookBuildMessage
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /playbooks/build/import_prompt:
    post:
      description: Starts a build conversation from a prompt the person wrote elsewhere
      tags: [ playbooks ]
      operationId: importPlaybookBuildPrompt
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /playbooks/build/draft:
    post:
      description: Builds the agent draft from the brief with the agent prompt builder
      tags: [ playbooks ]
      operationId: buildPlaybookDraft
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /playbooks/build/test:
    post:
      description: Runs the current draft on one client as a test that never appears in Results
      tags: [ playbooks ]
      operationId: testPlaybookDraft
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /playbooks/build/publish:
    post:
      description: Publishes the tested draft so the firm runs it
      tags: [ playbooks ]
      operationId: publishPlaybookDraft
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /playbooks/build/lines/waive:
    post:
      description: Waives a statement line of the draft that no check is about, with the person's reason
      tags: [ playbooks ]
      operationId: waivePlaybookDraftLine
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /playbooks/build/lines/clear_waiver:
    post:
      description: Removes the waiver on a statement line of the draft
      tags: [ playbooks ]
      operationId: clearPlaybookDraftLineWaiver
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /playbooks/build/gaps/waive:
    post:
      description: Builds without a gap the guide named, with the person's reason
      tags: [ playbooks ]
      operationId: waivePlaybookBuildGap
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /playbooks/build/gaps/drop:
    post:
      description: Drops the step a gap the guide named is about
      tags: [ playbooks ]
      operationId: dropPlaybookBuildGap
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /playbooks/build/gaps/reopen:
    post:
      description: Opens a waived or dropped gap again
      tags: [ playbooks ]
      operationId: reopenPlaybookBuildGap
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /playbooks/build/scripts/draft:
    post:
      description: Has Workflow write, or write again, the script for a gap of the open conversation
      tags: [ playbooks ]
      operationId: writePlaybookBuildScript
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /playbooks/build/scripts/edit:
    post:
      description: Saves a person's own change to a script of the open conversation
      tags: [ playbooks ]
      operationId: editPlaybookBuildScript
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /playbooks/build/scripts/test:
    post:
      description: Tests a script of the open conversation on one client and period
      tags: [ playbooks ]
      operationId: testPlaybookBuildScript
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /playbooks/build/scripts/regression:
    post:
      description: Compares a changed approved script with the stored test of its approval
      tags: [ playbooks ]
      operationId: comparePlaybookBuildScript
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /playbooks/build/scripts/review:
    post:
      description: Has the current version of a script of the conversation reviewed, as advice
      tags: [ playbooks ]
      operationId: reviewPlaybookBuildScript
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /playbooks/build/scripts/verdict:
    post:
      description: Marks one shown finding of a script review agreed or disagreed
      tags: [ playbooks ]
      operationId: markPlaybookBuildScriptFinding
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /playbooks/build/scripts/approve:
    post:
      description: Approves the current version of a script of the conversation, once it is tested and reviewed
      tags: [ playbooks ]
      operationId: approvePlaybookBuildScript
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /playbooks/build/scripts/list:
    post:
      description: Lists the conversation's scripts with their tests, reviews, approval and what approving still needs
      tags: [ playbooks ]
      operationId: listPlaybookBuildScripts
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /playbooks/build/scripts/library/add:
    post:
      description: Adds an approved script of the conversation to the firm's library, frozen as it was approved
      tags: [ playbooks ]
      operationId: addPlaybookScriptToLibrary
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /playbooks/build/scripts/library/take:
    post:
      description: Takes a script from the firm's library onto a gap of the conversation, approved as the library holds it
      tags: [ playbooks ]
      operationId: takePlaybookScriptFromLibrary
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /playbooks/scripts/library/list:
    post:
      description: Lists the firm's library of approved scripts that are not retired, newest first
      tags: [ playbooks ]
      operationId: listPlaybookScriptLibrary
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /playbooks/scripts/library/retire:
    post:
      description: Retires a script from the firm's library so it can no longer be taken
      tags: [ playbooks ]
      operationId: retirePlaybookScriptFromLibrary
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /playbooks/build/close:
    post:
      description: Closes a build conversation without publishing
      tags: [ playbooks ]
      operationId: closePlaybookBuild
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /playbooks/build/mine:
    post:
      description: The viewer open build conversations
      tags: [ playbooks ]
      operationId: listMyPlaybookBuilds
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /playbooks/build/files/remove:
    post:
      description: Removes a reference file from the agent being built; it stays on record
      tags: [ playbooks ]
      operationId: removePlaybookReferenceFile
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /playbooks/build/files/upload:
    post:
      description: Adds reference files to the agent being built (multipart form with sessionId and files)
      tags: [ playbooks ]
      operationId: uploadPlaybookReferenceFiles
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"
  /playbooks/changes/list:
    post:
      description: An agent's held changes, pending and recently decided, with their integrity reviews
      tags: [ playbooks ]
      operationId: listPlaybookChangeRequests
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /playbooks/changes/decide:
    post:
      description: Approves or rejects a held change to an agent; the creator or an administrator
      tags: [ playbooks ]
      operationId: decidePlaybookChangeRequest
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /playbooks/changes/withdraw:
    post:
      description: Withdraws the viewer's own held change to an agent
      tags: [ playbooks ]
      operationId: withdrawPlaybookChangeRequest
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"
  /playbooks/schedule/run_now:
    post:
      description: Starts the automatic agent runs due on a date for this firm straight away; outside production only
      tags: [ playbooks ]
      operationId: runPlaybookScheduleNow
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"
  /playbooks/runs/review/get:
    post:
      description: One agent run's suggestions with their decisions, last month's decisions, the latest re-check of the books, sign-offs and what the viewer may do
      tags: [ playbooks ]
      operationId: getPlaybookRunReview
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /playbooks/runs/review/evidence:
    post:
      description: One finding's proof and the rows the agent read for it, frozen as the run stored them, cited rows first
      tags: [ playbooks ]
      operationId: getPlaybookFindingEvidence
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /playbooks/runs/review/decide:
    post:
      description: Accepts or rejects one suggestion on an agent run; a rejection needs a reason category and a sentence
      tags: [ playbooks ]
      operationId: decidePlaybookSuggestion
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /playbooks/runs/review/confirm_still_applies:
    post:
      description: Carries last month's rejection of an unchanged suggestion forward as the viewer's decision
      tags: [ playbooks ]
      operationId: confirmPlaybookRejectionStillApplies
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /playbooks/runs/review/accept_all_low:
    post:
      description: Accepts every undecided low finding on an agent run
      tags: [ playbooks ]
      operationId: acceptAllLowPlaybookFindings
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /playbooks/runs/review/recheck:
    post:
      description: Re-runs the deterministic checks on the books and stores the result as the after picture
      tags: [ playbooks ]
      operationId: recheckPlaybookRunBooks
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /playbooks/runs/review/send:
    post:
      description: Sends an agent run whose suggestions are all decided to its reviewer, re-checking the books first
      tags: [ playbooks ]
      operationId: sendPlaybookRunForReview
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /playbooks/runs/review/sign_off:
    post:
      description: Signs off an agent run waiting on sign-off
      tags: [ playbooks ]
      operationId: signOffPlaybookRun
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /playbooks/runs/review/return:
    post:
      description: Returns an agent run waiting on sign-off to the people who decide, with a reason
      tags: [ playbooks ]
      operationId: returnPlaybookRunToPreparer
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /playbooks/runs/books/ledger:
    post:
      description: One account's ledger as QuickBooks holds it now for a playbook run's client, the run's month by default, with the cited lines that changed since the run
      tags: [ playbooks ]
      operationId: readPlaybookRunLedger
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /playbooks/runs/books/trial_balance:
    post:
      description: The trial balance as QuickBooks holds it now for a playbook run's client, from the fiscal year start to the run's period end
      tags: [ playbooks ]
      operationId: readPlaybookRunTrialBalance
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /playbooks/runs/books/transaction:
    post:
      description: One QuickBooks transaction of a playbook run's client by its ledger label and id, as a header and plain lines
      tags: [ playbooks ]
      operationId: readPlaybookRunTransaction
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /playbooks/runs/books/attachments:
    post:
      description: The files QuickBooks holds on one transaction of a playbook run's client
      tags: [ playbooks ]
      operationId: listPlaybookRunAttachments
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /playbooks/runs/books/attachment_view:
    get:
      description: One file attached to a transaction of a playbook run's client, sent inline with its content type; refused unless QuickBooks lists it on that transaction
      tags: [ playbooks ]
      operationId: viewPlaybookRunAttachment
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /playbooks/versions/get:
    post:
      description: One agent as the viewer may see it, with base instructions only if allowed and every addition with its author
      tags: [ playbooks ]
      operationId: getPlaybookForEditing
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /playbooks/versions/list:
    post:
      description: Every version of an agent with who saved it, why, and which additions changed
      tags: [ playbooks ]
      operationId: listPlaybookVersions
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /playbooks/versions/add_addition:
    post:
      description: Adds an instruction to an agent as a new version credited to the viewer
      tags: [ playbooks ]
      operationId: addPlaybookAddition
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /playbooks/versions/edit_addition:
    post:
      description: Rewrites one of the viewer's own additions as a new version
      tags: [ playbooks ]
      operationId: editPlaybookAddition
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /playbooks/versions/remove_addition:
    post:
      description: Takes one of the viewer's own additions out of an agent as a new version
      tags: [ playbooks ]
      operationId: removePlaybookAddition
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /playbooks/versions/edit_base:
    post:
      description: Rewrites an agent's base instructions as a new version; its author or an administrator only
      tags: [ playbooks ]
      operationId: editPlaybookBaseInstructions
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /playbooks/versions/roll_back:
    post:
      description: Goes back to an earlier agent version by saving a new one; other people's additions are kept
      tags: [ playbooks ]
      operationId: rollBackPlaybookVersion
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /playbooks/settings/get:
    post:
      description: An agent's settings, who its roles resolve to on each team, the settings history and the choices
      tags: [ playbooks ]
      operationId: getPlaybookSettings
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /playbooks/settings/save:
    post:
      description: Saves an agent's settings as a new version; administrator or partner group only
      tags: [ playbooks ]
      operationId: savePlaybookSettings
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"
  /tools/afs/agent_mode_manifest:
    post:
      description: Fetch the agent mode manifest for a client
      tags: [ tools ]
      operationId: agentModeManifest
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/afs/review:
    post:
      description: Generate an AI review of the AFS financial statements
      tags: [ tools ]
      operationId: reviewAFS
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/afs/compliance_checklist:
    post:
      description: Retrieve the compliance checklist for a client
      tags: [ tools ]
      operationId: complianceChecklist
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/afs/compliance_evidence:
    post:
      description: Set or clear a compliance evidence value for a client
      tags: [ tools ]
      operationId: complianceEvidence
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/afs/compliance_document:
    delete:
      description: Delete a compliance document for a client
      tags: [ tools ]
      operationId: deleteComplianceDocument
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/afs/compliance_acknowledge:
    post:
      description: Acknowledge or unacknowledge a compliance item for a client
      tags: [ tools ]
      operationId: complianceAcknowledge
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /gmail/auth_url:
    get:
      description: Get Google OAuth consent URL for connecting a user's Gmail account
      tags: [ gmail ]
      operationId: gmailAuthUrl
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /gmail/tasks/resync:
    post:
      description: Re-push the signed-in user's open backoffice tasks to their Google Tasks (after the Tasks API or scope was fixed)
      tags: [ gmail ]
      operationId: gmailTasksResync
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /gmail/status:
    get:
      description: Returns whether the current user has Gmail connected
      tags: [ gmail ]
      operationId: gmailStatus
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /gmail/disconnect:
    post:
      description: Disconnects the current user's Gmail account
      tags: [ gmail ]
      operationId: gmailDisconnect
      security: [
        authorization: [ default ]
      ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/bookkeeping/classify_tax:
    post:
      description: Classifies transactions for tax
      tags: [ tools ]
      operationId: classifyAccountsTax

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/bookkeeping/upload_caseware_reference:
    post:
      description: Uploads a Caseware reference file
      tags: [ tools ]
      operationId: uploadCasewareReference

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/reconciliation/upload:
    post:
      description: Upload PDF and Excel docs for reconciliation
      tags: [ tools ]
      operationId: upload

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/reconciliation/download:
    post:
      description: Downloads the Excel reconciliation
      tags: [ tools ]
      operationId: download

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/hstReconciliation/download:
    post:
      description: Downloads the Excel reconciliation
      tags: [ tools ]
      operationId: download

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/hstReconciliation/downloadQuickMethod:
    post:
      description: Downloads the Quick Method Excel reconciliation
      tags: [ tools ]
      operationId: download

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/jane_reports/quickbooks_accounts:
    post:
      description: List the client's QuickBooks chart of accounts for the Jane journal mapping
      tags: [ tools ]
      operationId: janeReportsQuickBooksAccounts

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/jane_reports/quickbooks_tax_codes:
    post:
      description: List the client's QuickBooks sales tax codes and propose which mean taxable and exempt
      tags: [ tools ]
      operationId: janeReportsQuickBooksTaxCodes

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/jane_reports/item_heads:
    post:
      description: List every item the period sold with the revenue account it credits
      tags: [ tools ]
      operationId: janeReportsItemHeads

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/jane_reports/item_heads_propose:
    post:
      description: Ask an AI which revenue account each unmapped item belongs to
      tags: [ tools ]
      operationId: janeReportsItemHeadsPropose

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/jane_reports/item_heads_confirm:
    post:
      description: Record a person's decision about which revenue account an item credits
      tags: [ tools ]
      operationId: janeReportsItemHeadsConfirm

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/jane_reports/site_pairings:
    post:
      description: List the sites this period sold from with the QuickBooks location or class each is paired with
      tags: [ tools ]
      operationId: janeReportsSitePairings

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/jane_reports/site_pairings_update:
    post:
      description: Save which QuickBooks location or class each of Jane's site names means
      tags: [ tools ]
      operationId: janeReportsSitePairingsUpdate

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/jane_reports/journal_shape:
    post:
      description: Read a client's Jane journal settings with who decided each, and a proposal for anything undecided
      tags: [ tools ]
      operationId: janeReportsJournalShape

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/jane_reports/journal_shape_update:
    post:
      description: Save a client's Jane journal settings
      tags: [ tools ]
      operationId: janeReportsJournalShapeUpdate

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/jane_reports/compare_previous:
    post:
      description: Compare the journal this tool would build against the last one the client posted
      tags: [ tools ]
      operationId: janeReportsComparePrevious

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/jane_reports/suggest_account_mappings:
    post:
      description: Propose an account for each Jane journal role from the client's previous journals
      tags: [ tools ]
      operationId: janeReportsSuggestAccountMappings

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/jane_reports/account_mappings:
    post:
      description: Read which QuickBooks account each Jane journal role posts to for a client
      tags: [ tools ]
      operationId: janeReportsAccountMappings

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/jane_reports/account_mappings_update:
    post:
      description: Save which QuickBooks account each Jane journal role posts to for a client
      tags: [ tools ]
      operationId: janeReportsAccountMappingsUpdate

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/jane_reports/build_journal:
    post:
      description: Build the Jane journal for a client from extracted figures and the saved account mapping
      tags: [ tools ]
      operationId: janeReportsBuildJournal

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/jane_reports/extract:
    post:
      description: Extract the journal figures from a set of uploaded Jane CSV exports for a standard client
      tags: [ tools ]
      operationId: janeReportsExtract

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/jane_reports/posted_journal:
    post:
      description: Read the journal entries already posted to QuickBooks for a client over a date range
      tags: [ tools ]
      operationId: janeReportsPostedJournal

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/loanReconciliation/accounts:
    get:
      description: List QBO loan / liability accounts available for loan reconciliation
      tags: [ tools ]
      operationId: loanReconAccounts

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/loanReconciliation/run:
    post:
      description: Run a loan reconciliation by uploading a lender's PDF statement
      tags: [ tools ]
      operationId: loanReconRun

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/loanReconciliation/history:
    get:
      description: List historical loan reconciliations for a client
      tags: [ tools ]
      operationId: loanReconHistory

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/loanReconciliation/schedule/get:
    get:
      description: Get the amortization schedule and history for a loan account
      tags: [ tools ]
      operationId: loanReconScheduleGet

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/loanReconciliation/schedule/generate:
    post:
      description: Generate an amortization schedule from provided loan terms
      tags: [ tools ]
      operationId: loanReconScheduleGenerate

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/loanReconciliation/schedule/upload:
    post:
      description: Upload an amortization schedule file for a loan account
      tags: [ tools ]
      operationId: loanReconScheduleUpload

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/loanReconciliation/schedule/replace:
    post:
      description: Replace an amortization schedule starting from a given date
      tags: [ tools ]
      operationId: loanReconScheduleReplace

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/loanReconciliation/schedule/recalculate:
    post:
      description: Recalculate the amortization schedule based on updated terms
      tags: [ tools ]
      operationId: loanReconScheduleRecalculate

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/loanReconciliation/schedule/reset:
    post:
      description: Reset an existing amortization schedule for a loan account
      tags: [ tools ]
      operationId: loanReconScheduleReset

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/loanReconciliation/schedule/updateRow:
    patch:
      description: Update status or notes on an amortization schedule row
      tags: [ tools ]
      operationId: loanReconScheduleUpdateRow

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/loanReconciliation/schedule/year:
    get:
      description: Get the amortization schedule year overview for a loan account
      tags: [ tools ]
      operationId: loanReconScheduleYear

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/bank_reconciliation/accounts:
    get:
      description: List QBO bank accounts available for reconciliation
      tags: [ tools ]
      operationId: bankReconAccounts

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/bank_reconciliation/run:
    post:
      description: Run a bank reconciliation for a specific account and period
      tags: [ tools ]
      operationId: bankReconRun

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/bank_reconciliation/get:
    get:
      description: Get a bank reconciliation by ID (pass reconciliationId as query param)
      tags: [ tools ]
      operationId: bankReconGet

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/bank_reconciliation/list:
    get:
      description: List reconciliation history for a client
      tags: [ tools ]
      operationId: bankReconList

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/bank_reconciliation/list_all:
    get:
      description: List all reconciliations across all clients for a given month
      tags: [ tools ]
      operationId: bankReconListAll

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/bank_reconciliation/data_quality_alerts:
    get:
      description: List active data quality alerts for a client
      tags: [ tools ]
      operationId: bankReconDataQualityAlerts

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"
    post:
      description: Acknowledge or resolve a data quality alert
      tags: [ tools ]
      operationId: bankReconAcknowledgeDataQualityAlert

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/bank_reconciliation/duplicate_decisions:
    post:
      description: Save a user's duplicate review decision (exclude/keep)
      tags: [ tools ]
      operationId: bankReconSaveDuplicateDecision

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/bank_reconciliation/update_item:
    post:
      description: Update a reconciliation item match status or category
      tags: [ tools ]
      operationId: bankReconUpdateItem

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/bank_reconciliation/download:
    post:
      description: Download bank reconciliation as Excel file
      tags: [ tools ]
      operationId: bankReconDownload

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/bank_reconciliation/auto_recon_settings:
    post:
      description: Enable/disable auto-reconciliation and map Plaid + QBO accounts
      tags: [ tools ]
      operationId: bankReconAutoReconSettings

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/bank_reconciliation/update_adjustment:
    post:
      description: Accept or reject a reconciliation adjustment
      tags: [ tools ]
      operationId: bankReconUpdateAdjustment

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/bank_reconciliation/post_adjustment:
    post:
      description: Post an accepted adjustment as a journal entry to QBO
      tags: [ tools ]
      operationId: bankReconPostAdjustment

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/plaid/connect/create_short_link:
    get:
      description: Creates a Plaid short link that can be shared with clients
      tags: [ tools ]
      operationId: createPlaidShortLink

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/plaid/connect/create_link_token:
    get:
      description: Creates a Plaid link token to start the plaid connection process
      tags: [ tools ]
      operationId: createPlaidLinkToken

      security: []

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/plaid/core/links:
    get:
      description: Fetches all the connection plaid links for a client
      tags: [ tools ]
      operationId: fetchPlaidLinks

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/plaid/core/send_connect_email:
    post:
      description: Will send a plaid link connect email to the contact
      tags: [ tools ]
      operationId: sendConnectEmail

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/plaid/core/health:
    get:
      description: Check Plaid connection health for a client
      tags: [ tools ]
      operationId: plaidHealth

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/plaid/connect/create_update_link_token:
    get:
      description: Create a Plaid Link token in update mode for re-authentication
      tags: [ tools ]
      operationId: createUpdateLinkToken

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/plaid/core/accounts:
    get:
      description: Fetches all the connected accounts for a Plaid account to a client
      tags: [ tools ]
      operationId: fetchPlaidAccounts

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/plaid/core/transactions:
    get:
      description: Fetches a list of transactions for a given account connected to workflow client and plaid account
      tags: [ tools ]
      operationId: fetchPlaidTransactions

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tools/plaid/hooks/webhook:
    post:
      description: Plaid Webhooks
      tags: [ tools ]
      operationId: plaidWebhook

      security: []

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /utility/crons/process_recurring_engagements:
    post:
      description: Test Cron endpoint
      tags: [ utility ]
      operationId: processRecurringEngagements

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /client_portal/auth/email_new_account_setup:
    post:
      description: Setup account 
      tags: [ client_portal ]
      operationId: emailNewAccountSetup
      security: [ authorization: [ default ] ]
      parameters:
        - name: body
          in: body
          required: true
          schema:
            type: object
            properties:
              contactId:
                type: integer
            required:
              - contactId
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /client_portal/auth/email_reset_password:
    post:
      description: Reset account password
      tags: [ client_portal ]
      operationId: emailResetPassword
      security: [ ]
      parameters:
        - name: body
          in: body
          description: email reset body request
          required: true
          schema:
            type: object
            properties:
              contactEmail:
                type: string
            required:
              - contactEmail
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"
        
  /client_portal/user/{contactId}/get_clients:
    get:
      description: get list of clients for user
      tags: [ client_portal ]
      operationId: getClients
      security: [ clientPortalAuthorization: [ default ]  ]
      parameters:
        - name: contactId
          in: path
          description: The ID of the contact
          required: true
          type: string
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /client_portal/auth/login:
    post:
      description: Login
      tags: [ client_portal ]
      operationId: login
      security: [ ]
      parameters:
        - in: body
          name: body
          description: Login request body
          required: true
          schema:
            type: object
            properties:
              email:
                type: string
              password:
                type: string
            required:
              - email
              - password
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /client_portal/auth/setup_account:
    post: 
      description: Setup account
      tags: [ client_portal ]
      operationId: setupAccount
      security: []
      parameters:
        - in: body
          name: body
          description: Setup account request body
          required: true
          schema:
            type: object
            properties:
              email:
                type: string
              password:
                type: string
              confirmedPassword:
                type: string
              setupToken: 
                type: string
            required:
              - email
              - password
              - confirmedPassword
              - setupToken
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /client_portal/file/upload:
    post:
      description: Upload a file
      consumes:
        - multipart/form-data
      tags: [ client_portal ]
      operationId: uploadFile
      security: [
         clientPortalAuthorization: [ default ] 
      ]
      parameters:
        - name: companyId
          in: formData
          description: Ignored; the firm is taken from the client's own record
          required: false
          type: integer
        - name: clientId
          in: formData
          description: Client ID
          required: true
          type: integer
        - name: files
          in: formData
          description: Files to upload
          # required is not supported for files with swagger
          type: array
          items:
            type: string
            format: binary

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /client_portal/file/remove:
    post:
      description: Delete a file
      tags: [ client_portal ]
      operationId: deleteFile
      security: [
         clientPortalAuthorization: [ default ] 
      ]
      parameters:
        - name: body
          in: body
          description: Delete file request body
          required: true
          schema:
            type: object
            properties:
              documentId:
                type: integer
              clientId:
                type: integer
              companyId:
                type: integer
                description: Ignored; the firm is taken from the client's own record
            required:
              - documentId
              - clientId
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"
  
  /client_portal/file/list:
    get:
      description: List files
      tags: [ client_portal ]
      operationId: listFiles
      security:
        - clientPortalAuthorization: [ default ]
      parameters:
        - name: clientId
          in: query
          description: The client ID
          required: true
          type: integer
        - name: search
          in: query
          description: Search term
          required: false
          type: string
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /client_portal/file/download:
    get:
      description: Download a file
      tags: [ client_portal ]
      operationId: downloadFile
      security: [
         clientPortalAuthorization: [ default ] 
      ]
      parameters:
        - name: companyId
          in: query
          description: Ignored; the firm is taken from the client's own record
          required: false
          type: integer
        - name: documentId
          in: query
          description: Document ID
          required: true
          type: integer
        - name: clientId
          description: client id of user
          in: query
          required: true
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /client_portal/google_drive/auth_url:
    get:
      description: The Google consent address for a signed-in admin to connect their own firm's Google Drive
      tags: [ client_portal ]
      operationId: auth_url
      security: [ authorization: [ default ] ]
      parameters:
        - name: clientId
          in: query
          description: Client ID
          required: true
          type: string
        - name: clientSecret
          in: query
          description: Client Secret
          required: true
          type: string
        - name: sharedDriveName
          in: query
          description: Shared drive name where files are stored
          required: true
          type: string

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"
  
  /client_portal/google_drive/callback:
    get:
      description: set token of google drive
      tags: [ client_portal ]
      operationId: callback
      security: []
      parameters:
        - name: code
          in: query
          required: true
          type: string
        - name: state
          in: query
          description: proxy state that is passed from auth url
          required: true
          type: string
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /client_portal/auth/{token}:
    get:
      description: Verify account setup auth token
      tags: [ client_portal ]
      operationId: verifyToken
      security: []
      parameters:
        - name: token
          in: path
          required: true
          type: string
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /faq/list:
    get:
      description: Fetch all active FAQ items
      tags: [ faq ]
      operationId: list

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /faq/search:
    post:
      description: AI-powered semantic search across FAQ transcripts
      tags: [ faq ]
      operationId: search

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /communications/list:
    post:
      description: List communications, optionally filtered by client, assignment, type, source, or date range
      tags: [ communication ]
      operationId: listCommunications

      security:
        - authorization: [ default ]
  /tracker/list:
    get:
      description: List the current user's tracker forms
      tags: [ tracker ]
      operationId: list

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tracker/create:
    post:
      description: Create a new tracker form
      tags: [ tracker ]
      operationId: create

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /communications/create:
    post:
      description: Manually log a communication for a client
      tags: [ communication ]
      operationId: createCommunication

      security:
        - authorization: [ default ]
  /tracker/rename:
    post:
      description: Rename a tracker form
      tags: [ tracker ]
      operationId: rename

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /communications/{communicationId}:
    get:
      description: Get a single communication with its AI summary
      tags: [ communication ]
      operationId: getCommunication

      security:
        - authorization: [ default ]
  /tracker/delete:
    post:
      description: Archive a tracker form
      tags: [ tracker ]
      operationId: delete

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /communications/{communicationId}/delete:
    post:
      description: Delete a logged communication
      tags: [ communication ]
      operationId: deleteCommunication

      security:
        - authorization: [ default ]
  /tracker/share:
    post:
      description: Share a tracker with the company or make it private
      tags: [ tracker ]
      operationId: share

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /communications/{communicationId}/assign:
    post:
      description: Assign an unmatched communication to a client
      tags: [ communication ]
      operationId: assignCommunication

      security:
        - authorization: [ default ]
  /tracker/save-config:
    post:
      description: Persist a tracker's view config
      tags: [ tracker ]
      operationId: saveConfig

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /communications/meet/list:
    post:
      description: List Google Meet transcript docs available to import for a client
      tags: [ communication ]
      operationId: listMeetRecordings

      security:
        - authorization: [ default ]
  /tracker/field-add:
    post:
      description: Add a column to a tracker form
      tags: [ tracker ]
      operationId: fieldAdd

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /communications/meet/import:
    post:
      description: Import selected Google Meet transcripts as communication entries
      tags: [ communication ]
      operationId: importMeetRecordings

      security:
        - authorization: [ default ]
  /tracker/field-update:
    post:
      description: Update a tracker column
      tags: [ tracker ]
      operationId: fieldUpdate

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /client/{clientId}/meetings/create:
    post:
      description: Schedule a Google Meet meeting for a client and store the calendar event link
      tags: [ client ]
      operationId: createMeeting

      security:
        - authorization: [ default ]
  /client/{clientId}/meetings/availability:
    post:
      description: Free/busy of the organizer and staff attendees for a proposed meeting slot
      tags: [ client ]
      operationId: meetingAvailability

      security:
        - authorization: [ default ]
  /tracker/field-delete:
    post:
      description: Delete a tracker column
      tags: [ tracker ]
      operationId: fieldDelete

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /client/{clientId}/meetings/list:
    get:
      description: List scheduled meetings for a client
      tags: [ client ]
      operationId: listMeetings

      security:
        - authorization: [ default ]

  /tracker/field-reorder:
    post:
      description: Reorder tracker columns
      tags: [ tracker ]
      operationId: fieldReorder

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tracker/grid:
    post:
      description: Get the tracker grid (POST; body may include filterTree, search by engagement/client name, plus limit/offset to page through the rows)
      tags: [ tracker ]
      operationId: grid

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tracker/value-upsert:
    post:
      description: Upsert a tracker cell value
      tags: [ tracker ]
      operationId: valueUpsert

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tracker/engagement-patch:
    post:
      description: Patch a whitelisted native engagement field
      tags: [ tracker ]
      operationId: engagementPatch

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tracker/field-list:
    post:
      description: List a form's columns for a resource
      tags: [ tracker ]
      operationId: fieldList
      security: [ authorization: [ default ] ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tracker/sub-grid:
    post:
      description: Load an engagement task/user sub-grid
      tags: [ tracker ]
      operationId: subGrid
      security: [ authorization: [ default ] ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tracker/sub-value-upsert:
    post:
      description: Upsert a sub-grid custom value
      tags: [ tracker ]
      operationId: subValueUpsert
      security: [ authorization: [ default ] ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tracker/task-patch:
    post:
      description: Patch a native task field / assignees
      tags: [ tracker ]
      operationId: taskPatch
      security: [ authorization: [ default ] ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tracker/user-patch:
    post:
      description: Patch a native user field / engagement member role
      tags: [ tracker ]
      operationId: userPatch
      security: [ authorization: [ default ] ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /tracker/sub-row-add:
    post:
      description: Add a task or user member to an engagement sub-grid
      tags: [ tracker ]
      operationId: subRowAdd
      security: [ authorization: [ default ] ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /data_mapper/registry:
    get:
      description: List datasource entities and relationships
      tags: [ data_mapper ]
      operationId: registry
      security: [ authorization: [ default ] ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /data_mapper/resolve:
    post:
      description: Resolve datasource dropdown options
      tags: [ data_mapper ]
      operationId: resolve
      security: [ authorization: [ default ] ]
      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /gmail/auth-url:
    get:
      description: Build a Google OAuth consent URL for connecting a team's Gmail mailbox
      tags: [ gmail ]
      operationId: authUrl

      security: [
        authorization: [ default ]
      ]

      parameters:
        - name: teamId
          in: query
          required: true
          type: integer

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /gmail/account-list:
    get:
      description: List Gmail accounts the current user can access
      tags: [ gmail ]
      operationId: accountList

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /gmail/account-disconnect:
    post:
      description: Disconnect a team Gmail account
      tags: [ gmail ]
      operationId: accountDisconnect

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /gmail/thread-list:
    get:
      description: List threads
      tags: [ gmail ]
      operationId: threadList

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /gmail/thread-get:
    get:
      description: Get a thread
      tags: [ gmail ]
      operationId: threadGet

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /gmail/message-update:
    post:
      description: Update message labels
      tags: [ gmail ]
      operationId: messageUpdate

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /gmail/message-trash:
    post:
      description: Trash a message or thread
      tags: [ gmail ]
      operationId: messageTrash

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /gmail/label-list:
    get:
      description: List user labels
      tags: [ gmail ]
      operationId: labelList

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /gmail/draft-create:
    post:
      description: Create draft
      tags: [ gmail ]
      operationId: draftCreate

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /gmail/draft-update:
    post:
      description: Update draft
      tags: [ gmail ]
      operationId: draftUpdate

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /gmail/draft-list:
    get:
      description: List drafts
      tags: [ gmail ]
      operationId: draftList

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /gmail/draft-get:
    get:
      description: Get a draft
      tags: [ gmail ]
      operationId: draftGet

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /gmail/draft-delete:
    post:
      description: Discard a draft
      tags: [ gmail ]
      operationId: draftDelete

      security: [
        authorization: [ default ]
      ]

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  # ---------------------------------------------------------------------------
  # Backoffice
  # ---------------------------------------------------------------------------

  /backoffice/client/list:
    get:
      description: Backoffice clients with their email contact
      tags: [ backoffice ]
      operationId: listClients

      security: [
        authorization: [ default ]
      ]

      x-scheme: /resource/subresource/action
      x-resource: backoffice
      x-expectedaction: list

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /backoffice/client/contacts:
    get:
      description: Contacts on a client, for picking the automation recipient
      tags: [ backoffice ]
      operationId: listClientContacts

      security: [
        authorization: [ default ]
      ]

      x-scheme: /resource/subresource/action
      x-resource: backoffice
      x-expectedaction: list
      parameters:
        - name: clientId
          in: query
          type: string
          required: false

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /backoffice/client/create:
    post:
      description: Enrol a client in backoffice
      tags: [ backoffice ]
      operationId: createClient

      security: [
        authorization: [ default ]
      ]

      x-scheme: /resource/subresource/action
      x-resource: backoffice
      x-expectedaction: create

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /backoffice/client/{backofficeClientId}/update:
    post:
      description: Update a backoffice client's contact, notes or status
      tags: [ backoffice ]
      operationId: updateClient

      security: [
        authorization: [ default ]
      ]

      x-scheme: /resource/subresource/identifier/action
      x-resource: backoffice
      x-expectedaction: update

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /backoffice/client/{backofficeClientId}/remove:
    post:
      description: Remove a client from backoffice
      tags: [ backoffice ]
      operationId: removeClient

      security: [
        authorization: [ default ]
      ]

      x-scheme: /resource/subresource/identifier/action
      x-resource: backoffice
      x-expectedaction: update

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /backoffice/task/list:
    get:
      description: Backoffice tasks with accounts and email automations
      tags: [ backoffice ]
      operationId: listTasks

      security: [
        authorization: [ default ]
      ]

      x-scheme: /resource/subresource/action
      x-resource: backoffice
      x-expectedaction: list
      parameters:
        - name: clientId
          in: query
          type: string
          required: false
        - name: service
          in: query
          type: string
          required: false
        - name: from
          in: query
          type: string
          required: false
        - name: to
          in: query
          type: string
          required: false
        - name: status
          in: query
          type: string
          required: false

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /backoffice/engagement/list:
    get:
      description: One client's backoffice tasks rolled up into engagements (one per service and period), read-only, for the client page's Backoffice tab
      tags: [ backoffice ]
      operationId: listBackofficeEngagements

      security: [
        authorization: [ default ]
      ]

      x-scheme: /resource/subresource/action
      x-resource: backoffice
      x-expectedaction: list
      parameters:
        - name: clientId
          in: query
          type: string
          required: true
        - name: service
          in: query
          type: string
          required: false
        - name: from
          in: query
          type: string
          required: false
        - name: to
          in: query
          type: string
          required: false
        - name: status
          in: query
          type: string
          required: false

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /backoffice/task/create:
    post:
      description: Create a backoffice task
      tags: [ backoffice ]
      operationId: createTask

      security: [
        authorization: [ default ]
      ]

      x-scheme: /resource/subresource/action
      x-resource: backoffice
      x-expectedaction: create

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /backoffice/task/{taskId}/update:
    post:
      description: Update a backoffice task; completing a recurring task creates the next occurrence
      tags: [ backoffice ]
      operationId: updateTask

      security: [
        authorization: [ default ]
      ]

      x-scheme: /resource/subresource/identifier/action
      x-resource: backoffice
      x-expectedaction: update

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /backoffice/task/{taskId}/remove:
    post:
      description: Delete a backoffice task
      tags: [ backoffice ]
      operationId: removeTask

      security: [
        authorization: [ default ]
      ]

      x-scheme: /resource/subresource/identifier/action
      x-resource: backoffice
      x-expectedaction: update

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /backoffice/task/{taskId}/restore:
    post:
      description: Bring back a deleted backoffice task
      tags: [ backoffice ]
      operationId: restoreTask

      security: [
        authorization: [ default ]
      ]

      x-scheme: /resource/subresource/identifier/action
      x-resource: backoffice
      x-expectedaction: update

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /backoffice/task/{taskId}/account/create:
    post:
      description: Add a tracked account to a task
      tags: [ backoffice ]
      operationId: addTaskAccount

      security: [
        authorization: [ default ]
      ]

      x-scheme: /resource/subresource/identifier/action
      x-resource: backoffice
      x-expectedaction: update

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /backoffice/task/{taskId}/account/{accountId}/update:
    post:
      description: Tick or edit a tracked account
      tags: [ backoffice ]
      operationId: updateTaskAccount

      security: [
        authorization: [ default ]
      ]

      x-scheme: /resource/subresource/identifier/action
      x-resource: backoffice
      x-expectedaction: update

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /backoffice/task/{taskId}/account/{accountId}/remove:
    post:
      description: Remove a tracked account from a task
      tags: [ backoffice ]
      operationId: removeTaskAccount

      security: [
        authorization: [ default ]
      ]

      x-scheme: /resource/subresource/identifier/action
      x-resource: backoffice
      x-expectedaction: update

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /backoffice/task/{taskId}/email/upsert:
    post:
      description: Save and activate the client email automation on a task
      tags: [ backoffice ]
      operationId: upsertTaskEmail

      security: [
        authorization: [ default ]
      ]

      x-scheme: /resource/subresource/identifier/action
      x-resource: backoffice
      x-expectedaction: update

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /backoffice/task/{taskId}/email/send_now:
    post:
      description: Send the automation email now and restart the cadence from today
      tags: [ backoffice ]
      operationId: sendTaskEmailNow

      security: [
        authorization: [ default ]
      ]

      x-scheme: /resource/subresource/identifier/action
      x-resource: backoffice
      x-expectedaction: update

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /backoffice/task/{taskId}/email/stop:
    post:
      description: Stop or pause the email automation on a task
      tags: [ backoffice ]
      operationId: stopTaskEmail

      security: [
        authorization: [ default ]
      ]

      x-scheme: /resource/subresource/identifier/action
      x-resource: backoffice
      x-expectedaction: update

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /backoffice/task/{taskId}/email/resume:
    post:
      description: Resume a stopped email automation from today
      tags: [ backoffice ]
      operationId: resumeTaskEmail

      security: [
        authorization: [ default ]
      ]

      x-scheme: /resource/subresource/identifier/action
      x-resource: backoffice
      x-expectedaction: update

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /backoffice/task/{taskId}/email/remove:
    post:
      description: Delete the email automation on a task
      tags: [ backoffice ]
      operationId: removeTaskEmail

      security: [
        authorization: [ default ]
      ]

      x-scheme: /resource/subresource/identifier/action
      x-resource: backoffice
      x-expectedaction: update

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /backoffice/email/send/{sendId}/skip:
    post:
      description: Skip one scheduled send
      tags: [ backoffice ]
      operationId: skipEmailSend

      security: [
        authorization: [ default ]
      ]

      x-scheme: /resource/subresource/identifier/action
      x-resource: backoffice
      x-expectedaction: update

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /backoffice/email/process_due:
    post:
      description: Deliver every due send now, administrators only (the cron does this in production)
      tags: [ backoffice ]
      operationId: processDueEmails

      security: [
        authorization: [ default ]
      ]

      x-scheme: /resource/subresource/action
      x-resource: backoffice
      x-expectedaction: update

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /backoffice/template/list:
    get:
      description: Backoffice task templates
      tags: [ backoffice ]
      operationId: listTemplates

      security: [
        authorization: [ default ]
      ]

      x-scheme: /resource/subresource/action
      x-resource: backoffice
      x-expectedaction: list
      parameters:
        - name: includeInactive
          in: query
          type: string
          required: false

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /backoffice/template/create:
    post:
      description: Create a backoffice template
      tags: [ backoffice ]
      operationId: createTemplate

      security: [
        authorization: [ default ]
      ]

      x-scheme: /resource/subresource/action
      x-resource: backoffice
      x-expectedaction: create

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /backoffice/template/{templateId}/update:
    post:
      description: Update a backoffice template and its tasks
      tags: [ backoffice ]
      operationId: updateTemplate

      security: [
        authorization: [ default ]
      ]

      x-scheme: /resource/subresource/identifier/action
      x-resource: backoffice
      x-expectedaction: update

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /backoffice/template/{templateId}/remove:
    post:
      description: Delete a backoffice template
      tags: [ backoffice ]
      operationId: removeTemplate

      security: [
        authorization: [ default ]
      ]

      x-scheme: /resource/subresource/identifier/action
      x-resource: backoffice
      x-expectedaction: update

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /backoffice/template/{templateId}/preview:
    get:
      description: Preview the tasks a template would add for a client and period
      tags: [ backoffice ]
      operationId: previewTemplate

      security: [
        authorization: [ default ]
      ]

      x-scheme: /resource/subresource/identifier/action
      x-resource: backoffice
      x-expectedaction: view
      parameters:
        - name: clientId
          in: query
          type: string
          required: false
        - name: periodStart
          in: query
          type: string
          required: false

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /backoffice/template/{templateId}/apply:
    post:
      description: Add a template's tasks to a client for a period
      tags: [ backoffice ]
      operationId: applyTemplate

      security: [
        authorization: [ default ]
      ]

      x-scheme: /resource/subresource/identifier/action
      x-resource: backoffice
      x-expectedaction: create

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /backoffice/capacity/list:
    get:
      description: Users with weekly backoffice capacity and teams
      tags: [ backoffice ]
      operationId: listCapacity

      security: [
        authorization: [ default ]
      ]

      x-scheme: /resource/subresource/action
      x-resource: backoffice
      x-expectedaction: list

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /backoffice/capacity/update:
    post:
      description: Set a user's weekly backoffice hours
      tags: [ backoffice ]
      operationId: updateCapacity

      security: [
        authorization: [ default ]
      ]

      x-scheme: /resource/subresource/action
      x-resource: backoffice
      x-expectedaction: update

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"

  /backoffice/chart_of_accounts/list:
    get:
      description: A client's reconcilable balance-sheet accounts
      tags: [ backoffice ]
      operationId: listChartOfAccounts

      security: [
        authorization: [ default ]
      ]

      x-scheme: /resource/subresource/action
      x-resource: backoffice
      x-expectedaction: list
      parameters:
        - name: clientId
          in: query
          type: string
          required: false

      responses:
        "200":
          description: Success
          schema:
            $ref: "#/definitions/Response"
        default:
          description: Error
          schema:
            $ref: "#/definitions/Response"


definitions:

  Request:
    description: Basic Request

  Response:
    description: A standard error response for all API methods.
`;
